import React, { useState } from "react";

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    fetch("https://formspree.io/f/xovwzopj", {
      method: "POST",
      body: data,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          setSubmitted(true);
          form.reset();
        } else {
          alert("Something went wrong. Please try again.");
        }
      })
      .catch((error) => {
        console.error(error);
        alert("Something went wrong. Please try again.");
      });
  };

  return (
    <section id="contact" className="py-20 bg-[#221E3F] text-left">
      <div className="max-w-3xl mx-auto px-6 sm:px-8">
        <div className="p-10 rounded-2xl bg-[#2a254d]/80 backdrop-blur-md border border-[#EF7C34]/40 shadow-lg">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">Contact Us</h2>
          <p className="text-lg text-slate-300 mb-10">
            Reach out with any questions, collaboration ideas, or to schedule a demo. We’d love to hear from you.
          </p>

          {submitted ? (
            <div className="p-6 bg-green-700/20 border border-green-500/30 rounded-xl text-green-300 text-lg shadow">
              ✅ Message sent! We'll be in touch soon.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <input type="hidden" name="_captcha" value="false" />

              <div>
                <label className="block text-slate-300 mb-1">Name</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-2 rounded-xl bg-[#1D1A35] text-white border border-slate-700/50 focus:outline-none focus:ring-2 focus:ring-[#EF7C34]/80"
                />
              </div>

              <div>
                <label className="block text-slate-300 mb-1">Email</label>
                <input
                  type="text"
                  name="Email"
                  className="w-full px-4 py-2 rounded-xl bg-[#1D1A35] text-white border border-slate-700/50 focus:outline-none focus:ring-2 focus:ring-[#EF7C34]/80"
                />
              </div>

              <div>
                <label className="block text-slate-300 mb-1">Organisation</label>
                <input
                  type="text"
                  name="organisation"
                  className="w-full px-4 py-2 rounded-xl bg-[#1D1A35] text-white border border-slate-700/50 focus:outline-none focus:ring-2 focus:ring-[#EF7C34]/80"
                />
              </div>

              <div>
                <label className="block text-slate-300 mb-1">Message</label>
                <textarea
                  name="message"
                  rows="5"
                  required
                  className="w-full px-4 py-2 rounded-xl bg-[#1D1A35] text-white border border-slate-700/50 focus:outline-none focus:ring-2 focus:ring-[#EF7C34]/80"
                />
              </div>

              {/* ✅ GDPR Privacy Disclaimer */}
              <p className="text-sm text-slate-400">
                By submitting this form, you agree to our{' '}
                <a href="/privacy-policy" className="underline text-white">
                  Privacy Policy
                </a>
                . We’ll use your details only to respond to your enquiry.
              </p>

              <button
                type="submit"
                className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] hover:from-orange-500 hover:to-yellow-400 px-6 py-3 rounded-xl font-semibold text-lg text-white transition-all transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                Send Message
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
